import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import FormattedContent from '@eversports/react-components/primitives/FormattedContent'
import Heading from '@eversports/react-components/primitives/Heading'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'
import { Card } from '../../typings/Product'

import CardAvailabilitiesInformation from './CardAvailabilitiesInformation'
import CardUsagesInformation from './CardUsagesInformation'
import CardValidityInformation from './CardValidityInformation'
import HTMLFormattedContentWrapper, { onATag, phoenixAllowList } from './HTMLFormattedContentWrapper'
import ValidActivities from './ValidActivities'
import ValidSports from './ValidSports'
import ValidVenues from './ValidVenues'
import WithdrawalInfo from './WithdrawalInfo'

const useStyles = makeStyles((theme: Theme) => ({
  cardLeftContainer: {
    flex: 0.7,
    marginRight: theme.layoutSpacing.wide,
    [theme.breakpoints.down('md')]: {
      flex: '1 0 100%',
      marginRight: 0,
    },
  },
}))

interface Props {
  product: Card
  hasActivityBasedParticipationRules: boolean
  isInMobileView: boolean
}

const CardModalContentDetails: React.FC<React.PropsWithChildren<Props>> = ({
  product,
  hasActivityBasedParticipationRules,
  isInMobileView,
}) => {
  const classes = useStyles()

  return (
    <Flex
      flexDirection="column"
      verticalSpacing="wide"
      className={hasActivityBasedParticipationRules ? classes.cardLeftContainer : undefined}
    >
      <Heading is="h5" color="primary.main" variant={isInMobileView ? 'large' : 'x-large'}>
        <MonetaryValue value={product.price.value} currencyCode={product.price.currency} />
      </Heading>
      {product.usages.length > 0 && (
        <CardUsagesInformation
          usages={product.usages}
          unlimitedUsages={product.unlimitedUsages}
          cardType={product.cardType}
        />
      )}
      {product.validity && <CardValidityInformation validity={product.validity} />}
      <ValidVenues venues={product.venues} />
      <ValidSports sports={product.sports} />
      {product.availabilities.length > 0 && <CardAvailabilitiesInformation availabilities={product.availabilities} />}
      {!hasActivityBasedParticipationRules && product.activities.length > 0 && (
        <ValidActivities activities={product.activities} />
      )}
      {product.description && (
        <div>
          <Text size="small" color="darkGray">
            <Localized id="product-description" />
          </Text>
          <FormattedContent
            htmlContent={product.description}
            WrapperComponent={HTMLFormattedContentWrapper}
            allowList={phoenixAllowList}
            onTag={onATag}
          />
        </div>
      )}
      {product.isWithdrawable && <WithdrawalInfo />}
    </Flex>
  )
}

export default CardModalContentDetails
